var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCombinedShapeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "6px",
    viewBox: "0 0 23 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.000000, -46.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2,46.7886297 L13.2,51.5874636 L12,51.5874636 L12,46.7886297 L13.2,46.7886297 Z M15.6,46.7886297 L15.6,51.5874636 L14.4,51.5874636 L14.4,46.7886297 L15.6,46.7886297 Z M18,46.7886297 L18,51.5874636 L16.8,51.5874636 L16.8,46.7886297 L18,46.7886297 Z M20.4,46.7886297 L20.4,51.5874636 L19.2,51.5874636 L19.2,46.7886297 L20.4,46.7886297 Z M22.8,46.7886297 L22.8,51.5874636 L21.6,51.5874636 L21.6,46.7886297 L22.8,46.7886297 Z M25.2,46.7886297 L25.2,51.5874636 L24,51.5874636 L24,46.7886297 L25.2,46.7886297 Z M27.6,46.7886297 L27.6,51.5874636 L26.4,51.5874636 L26.4,46.7886297 L27.6,46.7886297 Z M30,46.7886297 L30,51.5874636 L28.8,51.5874636 L28.8,46.7886297 L30,46.7886297 Z M32.4,46.7886297 L32.4,51.5874636 L31.2,51.5874636 L31.2,46.7886297 L32.4,46.7886297 Z M34.8,46.7886297 L34.8,51.5874636 L33.6,51.5874636 L33.6,46.7886297 L34.8,46.7886297 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShapeIcon);
export default __webpack_public_path__ + "static/media/combined-shape-icon.49baec9d.svg";
export { ForwardRef as ReactComponent };